import React from "react";
import ReactDOM from "react-dom/client";
import '@splidejs/splide/dist/css/splide.min.css'
import '@splidejs/splide/dist/js/splide.min.js'
import "./assets/css/homepage.css";
import "./assets/css/cmslandingpage.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import "./assets/css/style.css"
import "./assets/css/developerstyle.css"
import "./assets/css/master.css";
import { store } from "./_helpers/store";
import { Provider } from "react-redux";
import reportWebVitals from "./reportWebVitals";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Login from "./components/admin/auth/Login";
import NewLoginScreen from "./pages/NewLoginScreen/NewLoginScreen";
import App from "./App";
import Forgot from "./components/admin/auth/Forgot";
import ResetPassword from "./components/admin/auth/ResetPassword";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <Provider store={store}>
    <Router>
      <Routes>
        <Route path="/" element={<NewLoginScreen />} />
        <Route path="/Logout" element={<NewLoginScreen />} />
        {/* <Route path="/" element={<Login />} />
        <Route path="/Logout" element={<Login />} /> */}
        <Route path="/*" element={<App />} />

        {/* <Route path="/new-login" element={<NewLoginScreen />} /> */}

        <Route path="/ForgotPassword" element={<Forgot />} />
        <Route path="/resetpassword" element={<ResetPassword />} />
      </Routes>
    </Router>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
